import {
    ChevronLeftIcon,
    ChevronRightIcon,
    IconButton,
} from '@eventbrite/marmalade';
import React from 'react';
import { gettext } from '../../../i18n';
import styles from '../SimpleCarousel.module.scss';
import { NavDirections, SlideConfig } from '../types';

/**
 * Header prev/next controls. Already Marmalade in eb-ui — kept 1:1.
 * `@eventbrite/feature-detection`'s `HAS_WINDOW` → a local
 * `typeof window !== 'undefined'` check (the whole helper).
 */
export const CarouselNavigation: React.FunctionComponent<
    CarouselNavigationProps
> = (props) => {
    if (props.childrenLength === 1 && !props.fullyEnableNavigation) {
        return null;
    }

    const hideNavigation = () => {
        if (typeof window === 'undefined') {
            return;
        }

        if (window.innerWidth > 1080) {
            // For desktop view
            return props.childrenLength <= props.slidesVisible.desktop;
        }
        if (window.innerWidth > 660) {
            // For tablet view
            return props.childrenLength <= props.slidesVisible.tablet;
        }
        return false;
    };

    const classes =
        hideNavigation() && !props.fullyEnableNavigation
            ? `${styles.navigation} ${styles.navigationDesktopHide}`
            : styles.navigation;

    return (
        <div className={classes} data-testid="carousel-navigation">
            <IconButton
                icon={<ChevronLeftIcon size="large" />}
                onClick={() => props.handleClick(NavDirections.Left)}
                aria-label={gettext('Scroll carousel left')}
                disabled={props.leftDisabled}
                outline
            />
            <span style={{ paddingLeft: '8px' }} />
            <IconButton
                icon={<ChevronRightIcon size="large" />}
                onClick={() => props.handleClick(NavDirections.Right)}
                aria-label={gettext('Scroll carousel right')}
                disabled={props.rightDisabled}
                outline
            />
        </div>
    );
};

interface CarouselNavigationProps {
    handleClick: (direction: NavDirections) => void;
    childrenLength: number;
    slidesVisible: SlideConfig;
    leftDisabled: boolean;
    rightDisabled: boolean;
    fullyEnableNavigation?: boolean;
}
